import { NRLogo } from '../ui/NRLogo';
import { MoreDotsIcon } from '../ui/icons';
import { useT } from '../../i18n';

export interface HeaderBarProps {
  tab: 'buy' | 'sell';
  onTabSwitch: (tab: 'buy' | 'sell') => void;
  showFlowToggle: boolean;
  showSettings: boolean;
  onOpenSettings: () => void;
  darkMode: boolean;
}

export function HeaderBar({
  tab,
  onTabSwitch,
  showFlowToggle,
  showSettings,
  onOpenSettings,
}: HeaderBarProps) {
  const t = useT();
  return (
    <div
      className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between px-3"
      style={{
        height: 80,
        background: 'var(--t-header-bg)',
        backdropFilter: `blur(var(--t-header-blur))`,
        WebkitBackdropFilter: `blur(var(--t-header-blur))`,
      }}
    >
      {/* Left: NR logo */}
      <div style={{ width: 46, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <NRLogo width={46} />
      </div>

      {/* Center: pill tab switcher */}
      {showFlowToggle ? (
        <div
          className="relative flex"
          style={{
            border: '1.5px solid var(--t-tab-border)',
            borderRadius: 'var(--t-pill-radius)',
            padding: 4,
            gap: 4,
          }}
        >
          {/* Sliding indicator */}
          <div
            style={{
              position: 'absolute',
              top: 4,
              left: 4,
              width: 88,
              height: 32,
              borderRadius: 'var(--t-pill-radius)',
              background: 'var(--t-tab-active-bg)',
              transform: tab === 'buy' ? 'translateX(0)' : 'translateX(92px)',
              transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              zIndex: 0,
            }}
          />
          <button
            onClick={() => onTabSwitch('buy')}
            className={`text-[13px] font-medium transition-colors duration-200 tab-pill${tab === 'buy' ? ' tab-pill-active' : ''}`}
            style={{
              position: 'relative',
              zIndex: 1,
              width: 88,
              height: 32,
              borderRadius: 'var(--t-pill-radius)',
              color: tab === 'buy' ? 'var(--t-tab-active-text)' : 'var(--t-tab-inactive-text)',
            }}
          >
            {t('header.buy')}
          </button>
          <button
            onClick={() => onTabSwitch('sell')}
            className={`text-[13px] font-medium transition-colors duration-200 tab-pill${tab === 'sell' ? ' tab-pill-active' : ''}`}
            style={{
              position: 'relative',
              zIndex: 1,
              width: 88,
              height: 32,
              borderRadius: 'var(--t-pill-radius)',
              color: tab === 'sell' ? 'var(--t-tab-active-text)' : 'var(--t-tab-inactive-text)',
            }}
          >
            {t('header.sell')}
          </button>
        </div>
      ) : (
        <div />
      )}

      {/* Right: menu dots */}
      <div style={{ width: 40, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        {showSettings ? (
          <MoreDotsIcon onClick={onOpenSettings} />
        ) : (
          <div style={{ width: 40 }} />
        )}
      </div>
    </div>
  );
}
